var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-banner"},[_c('h1',{staticClass:"banner-title"},[_c('b',[_vm._v(_vm._s(this.productTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }